import gql from 'graphql-tag';

export const UPDATE_TEAM_PAYMENT_METHOD = gql `
    mutation UpdateTeamPaymentMethod($teamId: Int!, $input: AgencySubscribe!) {
        updateTeamPaymentMethod(teamId: $teamId, input: $input)
  }
`;